export default function SectionHeader({ sectionName, sectionDescription }: { sectionName: any, sectionDescription: string }) {
    return (
        <div className='h-28 flex flex-col lg:flex-row justify-center lg:justify-between items-start lg:items-center font-lora tracking-tighter gap-3'>
            <p className='text-xl'>{sectionName}</p>
            <p className='bg-green-gradient90-op bg-opacity-60 px-3 py-1 rounded-lg'>{sectionDescription}</p>
        </div>
    )
}